<template>
  <div
    class="contentWrap"
    :style="{
      backgroundImage:
        'url(' +
        $returnColor().path +
        ($store.state.selfData.member_id
          ? '/home-page_bg.png'
          : '/home-page_bg.png') +
        ')',
    }"
  >
    <!-- dialog -->
    <!-- dialog -->
    <!-- top -->
    <!-- top -->
    <div style="margin-bottom: 15px"></div>
    <van-cell-group inset style="margin: 0 0 15px 0; width: 295px">
      <div class="tWrap">
        <p class="title chF">金额统计</p>
        <div class="wrapContent">
          <div class="top">
            <div class="wrapTitle">
              <p class="chF">余额</p>
              <p class="numF">¥ {{ stats.balance | thousands }}</p>
            </div>
            <div class="wrapTitle">
              <p class="chF">红利</p>
              <p class="numF">¥ {{ stats.bonus | thousands }}</p>
            </div>
          </div>
          <div class="bottom" v-if="stats.bonus">
            <div class="tContent">
              <div class="tContentWrap">
                <p class="chF">今日总红利</p>
                <p class="numF">
                  ¥{{ stats.bonus_stats[0].today | thousands }}
                </p>
              </div>
              <div class="tContentWrap">
                <p class="chF">昨日总红利</p>
                <p class="numF">
                  ¥{{ stats.bonus_stats[0].yesterday | thousands }}
                </p>
              </div>
            </div>
            <div class="tContent">
              <div class="tContentWrap">
                <p class="chF">今日完成笔数</p>
                <p class="numF">{{ stats.order.count | thousands }}</p>
              </div>
              <div class="tContentWrap">
                <p class="chF">今日完成金额</p>
                <p class="numF">¥{{ stats.order.amount | thousands }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-cell-group>
    <div style="width: 295px">
      <div class="tSelectWrap">
        <div class="tSelect">
          <span @click="getMethod = '0'" :class="{ active: getMethod == '0' }"
            >待付款</span
          >
          <span @click="getMethod = '1'" :class="{ active: getMethod == '1' }"
            >成功</span
          >
          <span @click="getMethod = '2'" :class="{ active: getMethod == '2' }"
            >逾时失效
          </span>
          <span @click="getMethod = '3'" :class="{ active: getMethod == '3' }"
            >金额错误</span
          >
          <span @click="getMethod = '4'" :class="{ active: getMethod == '4' }"
            >实名不符</span
          >
          <span @click="getMethod = '5'" :class="{ active: getMethod == '5' }"
            >失败</span
          >
        </div>
        <van-icon
          name="search"
          class="searchIcon"
          @click="$router.push('/orderCRecord')"
        />
      </div>
      <div class="cardWrap" v-for="order in orders.data" :key="order.order_id">
        <div class="left">
          <img
            v-if="
              order.content &&
              Array.isArray(order.content) &&
              order.content.length
            "
            :src="order.content[0].img"
            alt=""
          />
          <div class="orderContent">
            <p v-if="order.bank_name == '抖音红包'" style="font-size: 14px">
              口令码: {{ order.bank_branch }}
            </p>
            <div class="amountWrap">
              <div>
                <p style="font-size: 12px">金额</p>
                <p class="amount">
                  ¥ {{ String(order.amount).split(".00")[0] }} -
                  {{ $returnMarkName(order.real_name) }}
                </p>
                <p style="font-size: 10px; width: 100%">{{ order.order_id }}</p>
                <p>{{ order.created_at }}</p>
              </div>
              <div class="tag">
                <span style="white-space: nowrap"
                  ><van-icon name="balance-o" style="font-size: 16px" />{{
                    order.status_ch
                  }}</span
                >
              </div>
              <!-- <van-tag
                round
                style="padding: 2px 8px; font-weight: bold"
                text-color="rgb(251,199,42)"
                :color="'rgba(255, 244, 228)'"
              >
                <span style="white-space: nowrap"
                  ><van-icon name="balance-o" />{{ order.status_ch }}</span
                >
              </van-tag> -->
              <!-- :type="returnTagType(order.status)" -->
            </div>
            <p
              class="boder-top"
              v-if="
                order.content &&
                Array.isArray(order.content) &&
                order.content.length
              "
              style="overflow: hidden; padding-top: 5px; color: #646566"
            >
              {{ order.content[0].name }}
              <span
                style="display: none"
                v-if="
                  order.content &&
                  Array.isArray(order.content) &&
                  order.content.length
                "
              >
                {{ (order.name = order.content[0].name) }}
                {{ (order.img = order.content[0].img) }}
                {{ (order.price = order.content[0].price) }}
              </span>
              <span v-else>
                {{ order.content }}
              </span>
            </p>
          </div>
        </div>
        <div class="bottom" @click="checkOrder(order)">
          <div class="bottomBtn">
            <p>查看详细内容</p>
          </div>
        </div>
      </div>
    </div>
    <foor />
  </div>
</template>
<script>
import { mapState } from "vuex";
import foor from "../../components/footer";

export default {
  components: {
    foor,
  },
  data() {
    return {
      setOrderModal: false,
      orderForm: {},
      currentOrder: {},
      getMethod: "0",
      stats: {
        order: {},
      },
      loadingMore: false, // ✅ 防止重複滾動觸發
    };
  },
  computed: {
    ...mapState(["orders", "pOrders", "isReLoadding", "except"]),
  },
  watch: {
    getMethod() {
      this.$store.dispatch("getOrder", { page: 1, status: this.getMethod });
    },
  },
  methods: {
    returnTagType(status) {
      if (status == 0) return "warning";
      if (status == 1) return "success";
      return "danger";
    },
    grabPOrder(order) {
      let vm = this;
      this.$dialog.confirm({
        title: "抢单",
        message: `抢单金额${order.amount}`,
        beforeClose(method, done) {
          if (method == "confirm") {
            vm.$http
              .post(`/mobile/payments/${order.order_id}/catch`)
              .then((res) => {
                if (res.data.code == 0) {
                  vm.$toast.success("抢单成功");
                  vm.$store.dispatch("getPOrder");
                  done();
                } else {
                  done();
                }
              });
          } else {
            done();
          }
        },
      });
    },
    getStats() {
      this.$http.get(`/mobile/stats`).then((res) => {
        if (res.data.code == 0) {
          this.stats = res.data.data;
        }
      });
    },
    checkOrder(order) {
      this.$router.push({
        name: "orderCInfo",
        params: order,
        query: order,
      });
    },
    checkPOrder() {
      this.$router.push(`/orderPInfo`);
    },
    scrollPage() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const clientHeight = document.documentElement.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight;

      const isBottom = scrollTop + clientHeight >= scrollHeight - 10;

      const nextPage = this.orders?.next_page;
      const currentPage = this.orders?.current_page;

      if (isBottom && nextPage && !this.loadingMore) {
        this.loadingMore = true;

        const params = {
          status: this.getMethod,
          page: currentPage + 1,
        };

        this.$store.dispatch("getOrder", params).finally(() => {
          this.loadingMore = false;
        });
      }
    },
  },
  created() {
    if (this.$route.query.getMethod) {
      this.getMethod = this.$route.query.getMethod;
    }
    this.getStats();
    this.$store.dispatch("getOrder", { page: 1, status: this.getMethod });
  },
  mounted() {
    window.addEventListener("scroll", this.scrollPage);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollPage);
  },
};
</script>

<style lang="scss" scoped>
.numF {
  font-family: "Montserrat" !important;
}
.cardFooter {
  display: flex;
  button {
    width: 50%;
  }
}
.dialogInfo {
  padding: 0 5px;
  color: rgb(219, 99, 101);
  font-size: 14px;
}
.selectBox {
  width: 80px;
  height: 80px;
  background-color: #fff;
  display: flex;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #cccccc;
  font-size: 10px;
  // padding: 20px;
}
.selectBox.active {
  border: 1px solid black;
  color: black;
}
.tWrap {
  display: flex;
  justify-content: space-around;
  text-align: center;
  padding: 20px;
  flex-direction: column;
  .title {
    font-size: 11pt;
  }
  // flex-wrap: wrap;
  .wrapContent {
    display: flex;
    flex-direction: column;
  }
  .top {
    display: flex;
    width: 100%;
    padding: 5px;
  }
  .wrapTitle {
    font-weight: 500;
    font-size: 18px;
    width: 50%;
    text-align: center;
    &:first-child {
      border-right: 1px solid rgba(#cccccc, 0.3);
    }
    &:last-child {
      // border-left: 0.5px solid rgba(#cccccc, 0.3);
    }
    p:first-child {
      font-size: 14px;
    }
    p.numF {
      font-size: 18px;
      margin-top: 5px;
    }
  }
  .bottom {
    display: flex;
    width: 100%;
    padding-top: 5px;
    border-top: 1px solid rgba(#cccccc, 0.3);
    .tContent {
      width: 50%;
      &:first-child {
        border-right: 1px solid rgba(#cccccc, 0.3);
      }
      .tContentWrap {
        .numF {
          margin-top: 10px;
        }
        p {
          &:first-child {
            color: #9d9b9b;
          }
        }
        .numF {
          font-size: 16px;
        }
      }
    }
  }
}
.tSelectWrap {
  width: 100%;
  height: 35px;
  border-radius: 20px;
  background-color: #fff;
  margin-bottom: 15px;
  padding-left: 15px;
  display: flex;
  padding-right: 40px;
  align-items: center;
  position: relative;
  .tSelect {
    overflow-x: scroll;
    display: flex;
    max-width: 100%;

    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
  }
  .searchIcon {
    position: absolute;
    right: 0px;
  }
  span {
    font-size: 12px;
    line-height: 34px;
    margin-right: 10px;
    // color: #9d9b9b;
    color: black;
    white-space: nowrap;
    &.active {
      color: red;
      border-bottom: 2px solid black;
    }
  }
  i {
    margin-left: auto;
    margin-right: 15px;
    font-size: 20px;
  }
}
.contentWrap {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.contentWrap {
  // background-image: url("/home-page_bg.png");
  background-repeat: no-repeat;
  min-height: 100vh;
  background-position: top center;
  width: 100vw;
  background-size: cover;
  background-attachment: fixed;
}

.cardWrap {
  background-color: #fff;
  border-radius: 5px;
  // height: 42px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  padding: 10px;
  flex-direction: column;
  padding-bottom: 5px;
  .amount {
    color: #f15a24;
    font-size: 14px;
  }
  .orderContent {
    width: 100%;
  }
  .amountWrap {
    display: flex;
    // flex-direction: column
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
  }
  .left {
    display: flex;
    width: 100%;
    align-items: center;
    position: relative;
    p {
      width: 120px;
      font-size: 12px;
      font-weight: bold;
      &.boder-top {
        // color: #cccccc;
        border-top: 1px solid rgba(220, 236, 225, 1);
        width: 100%;
      }
    }
    img {
      width: 80px;
      height: 80px;
      // margin-left: 15px;
      margin-right: 15px;
    }
  }
  .bottom {
    width: 100%;
    margin-top: 15px;
    border-top: 1px solid rgba(gray, 0.3);
    .bottomBtn {
      text-align: center;
      padding: 5px 0;
      color: #4dcca2;
    }
  }
  .right {
    .orderContent {
      display: flex;
      font-weight: bold;
      width: 100%;
      p {
        margin-right: 15px;
      }
      button {
        margin-right: 10px;
        font-size: 12px;
      }
    }
  }
}
.tag {
  background-color: rgb(255, 244, 228);
  padding: 2px 8px;
  font-weight: bold;
  color: rgb(251, 199, 42);
  border-radius: 100px;
  font-size: 12px;
  position: absolute;
  right: 5px;
  top: 0px;
}
</style>
